import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["documentList", "counter", "error", "submitButton"]

  connect() {
    this.updateCounter()
  }

  selectAll() {
    this.checkboxes.forEach(checkbox => checkbox.checked = true)
    this.updateCounter()
    this.hideError()
  }

  deselectAll() {
    this.checkboxes.forEach(checkbox => checkbox.checked = false)
    this.updateCounter()
  }

  toggle() {
    this.updateCounter()
    this.hideError()
  }

  updateCounter() {
    if (!this.hasCounterTarget) return

    const total = this.checkboxes.length
    const selected = this.selectedCount
    this.counterTarget.textContent = `${selected} of ${total} selected`
  }

  validateAndSubmit(event) {
    if (this.selectedCount === 0 && this.checkboxes.length > 0) {
      event.preventDefault()
      this.showError()
      return false
    }
    return true
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
    }
  }

  get checkboxes() {
    if (!this.hasDocumentListTarget) return []
    return Array.from(this.documentListTarget.querySelectorAll('input[type="checkbox"]'))
  }

  get selectedCount() {
    return this.checkboxes.filter(cb => cb.checked).length
  }
}
